import { Stack, StackProps } from '@mantine/core';

export function OnboardingLayoutBody({ children, ...rest }: StackProps) {
    return <Stack mt="sm" mr={0} {...rest}>{children}</Stack>;
}
